import { render, staticRenderFns } from "./CatalogFiltersParameter.vue?vue&type=template&id=5be3b4a4&"
import script from "./CatalogFiltersParameter.js?vue&type=script&lang=js&"
export * from "./CatalogFiltersParameter.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports